import { observer } from 'mobx-react';
import { useMemo } from 'react';
import { FormTemplate } from '../../../../../../../../../Resource/FormTemplates/Types';
import { Link } from '../../../../../../../../../Resource/Types';
import { T } from '../../../../../../../../../Translations';
import CopyLinkButton from './CopyLinkButton';
import { LearningCollectionPublishResource } from '../../Store/Types';
import InviteButton from './InviteButton';
import InviteParticipantsModal from './InviteParticipantModal';
import InviteParticipantStore from './InviteParticipantModal/Store';
import InviteParticipantReactions from './InviteParticipantModal/Store/Reactions';

export interface Props {
  link: Link;
  learningCollectionPublishResource: LearningCollectionPublishResource;
  template: FormTemplate;
}

function InviteModalAndShareUrl({ link, learningCollectionPublishResource, template }: Props) {
  const inviteParticipantStore = useMemo(() => new InviteParticipantStore(), []);

  return (
    <>
      <div className="mt-6 max-w-full flex flex-col">
        <InviteButton
          inviteParticipantStore={inviteParticipantStore}
          links={learningCollectionPublishResource.links}
        />
        <CopyLinkButton link={link} />
        <a
          className="mt-6 text-center font-medium text-teal-600 cursor-pointer"
          target="_blank"
          rel="noopener noreferrer"
          href="https://execonline.atlassian.net/l/cp/wSV9j2Jr"
          data-intercom-target="builder-learn-more-about-sharing-with-participants-link"
        >
          <T kind="Learn more about sharing with participants" />
        </a>
      </div>
      <InviteParticipantsModal
        learningCollectionPublishResource={learningCollectionPublishResource}
        inviteParticipantStore={inviteParticipantStore}
        template={template}
      />
      <InviteParticipantReactions
        store={inviteParticipantStore}
        learningCollectionPublishResource={learningCollectionPublishResource}
        template={template}
        fireImmediately
      />
    </>
  );
}

export default observer(InviteModalAndShareUrl);
